(function(){
  const MOBILE_BREAKPOINT = 750;

  function getCollapsedHeight(){
    return window.innerWidth < MOBILE_BREAKPOINT ? 250 : 360;
  }

  function initCollectionDescription(root){
    const wraps = (root || document).querySelectorAll('.cap-desc-wrap--collection');
    wraps.forEach((wrap) => {
      if (wrap.dataset.capDescInit === 'true') {
        updateCollectionDescription(wrap);
        return;
      }

      const content = wrap.querySelector('[data-cap-desc-content]');
      const button = wrap.querySelector('[data-cap-desc-toggle]');
      if (!content || !button) return;

      wrap.dataset.capDescInit = 'true';
      button.addEventListener('click', function(){
        const expanded = button.getAttribute('aria-expanded') === 'true';
        expanded ? collapseCollectionDescription(wrap) : expandCollectionDescription(wrap);
      });

      updateCollectionDescription(wrap);
    });
  }

  function updateCollectionDescription(wrap){
    const content = wrap.querySelector('[data-cap-desc-content]');
    const button = wrap.querySelector('[data-cap-desc-toggle]');
    if (!content || !button) return;

    const collapsedHeight = getCollapsedHeight();

    content.style.maxHeight = 'none';
    const fullHeight = content.scrollHeight;

    if (fullHeight <= collapsedHeight + 20) {
      content.style.maxHeight = 'none';
      content.classList.remove('cap-collapsed');
      wrap.classList.remove('is-collapsed', 'is-expanded');
      button.hidden = true;
      button.style.display = 'none';
      button.setAttribute('aria-expanded', 'false');
      button.textContent = 'Mostra di più';
      return;
    }

    button.hidden = false;
    button.style.display = '';

    if (button.getAttribute('aria-expanded') === 'true') {
      content.style.maxHeight = fullHeight + 'px';
      content.classList.remove('cap-collapsed');
      wrap.classList.add('is-expanded');
      wrap.classList.remove('is-collapsed');
      button.textContent = 'Mostra meno';
    } else {
      content.style.maxHeight = collapsedHeight + 'px';
      content.classList.add('cap-collapsed');
      wrap.classList.add('is-collapsed');
      wrap.classList.remove('is-expanded');
      button.textContent = 'Mostra di più';
    }
  }

  function collapseCollectionDescription(wrap){
    const button = wrap.querySelector('[data-cap-desc-toggle]');
    if (!button) return;
    button.setAttribute('aria-expanded', 'false');
    updateCollectionDescription(wrap);
  }

  function expandCollectionDescription(wrap){
    const button = wrap.querySelector('[data-cap-desc-toggle]');
    if (!button) return;
    button.setAttribute('aria-expanded', 'true');
    updateCollectionDescription(wrap);
  }

  document.addEventListener('DOMContentLoaded', function(){
    initCollectionDescription(document);
  });

  document.addEventListener('shopify:section:load', function(event){
    initCollectionDescription(event.target);
  });

  let resizeTimer;
  window.addEventListener('resize', function(){
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function(){
      document.querySelectorAll('.cap-desc-wrap--collection').forEach(updateCollectionDescription);
    }, 120);
  });
})();
